import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=6b4d334b&scoped=true"
import script from "./PageTabs.vue?vue&type=script&lang=js"
export * from "./PageTabs.vue?vue&type=script&lang=js"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=6b4d334b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4d334b",
  null
  
)

export default component.exports